module.exports = __webpack_public_path__ + "static/img/7.0bea5c25.png";